import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  Button, Form, Message, Segment, Divider
} from 'semantic-ui-react'
import GoogleLogin from 'react-google-login'
import { path } from 'ramda'
import AuthActions from 'Redux/AuthRedux'
import styles from './ResetPasswordStyles'

class ResetPasswordForm extends Component {
  constructor (props) {
    super(props)

    this.state = {
      password: '',
      password_confirmation: ''
    }
    this.headers = {}
  }

  componentDidMount () {
    this.props.authReset()
    const params = new URLSearchParams(this.props.location.search)
    this.headers = {
      'access-token': params.get('access-token'),
      'client': params.get('client'),
      'token-type': params.get('token-type'),
      'uid': params.get('uid')
    }
  }

  onResetPassword = () => {
    let redirectTo = '/projects'
    const projectId = path(['params', 'projectId'], this.props.match)
    if (projectId) {
      redirectTo += '/' + projectId
    }
    this.props.resetPasswordRequest(this.state, this.headers, redirectTo)
  }

  onPassChange = (e, { value }) => {
    this.setState({ [e.target.name]: value })
  }

  render () {
    return (
      <div className={styles.resetPasswordForm}>
        {this.props.error &&
          <Message color='red'>{this.props.error}</Message>
        }
        <Message>Just one last step for security purposes.</Message>
        <Form size='large'>
          <Segment stacked>
            <GoogleLogin
              clientId="669262296891-9sl0ol8qsmndbqvrg66qm5ubr8nhebqs.apps.googleusercontent.com"
              buttonText="Sign in with Google"
              onSuccess={this.props.googleLoginRequest}
              onFailure={() => {}}
              cookiePolicy={'single_host_origin'}
              scope='email profile'
              responseType='code'
            />
            <Divider
              className={styles.divider}
              horizontal>Or</Divider>
            <Form.Input
              name='password'
              fluid
              icon='lock'
              iconPosition='left'
              placeholder='New Password'
              type='password'
              onChange={this.onPassChange}
            />
            <Form.Input
              name='password_confirmation'
              fluid
              icon='lock'
              iconPosition='left'
              placeholder='Confirm Password'
              type='password'
              onChange={this.onPassChange}
            />
            <Button
              primary
              size='large'
              onClick={this.onResetPassword}
              loading={this.props.fetching} >
                Set Password
            </Button>
          </Segment>
        </Form>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  fetching: state.auth.fetching,
  error: state.auth.error,
  data: state.auth.authData
})

const mapDispatchToProps = (dispatch) => ({
  googleLoginRequest: (authData) =>
    dispatch(AuthActions.googleLoginRequest(authData)),
  authReset: _ => dispatch(AuthActions.authReset()),
  resetPasswordRequest: (params, headers, redirectTo) =>
    dispatch(AuthActions.resetPasswordRequest(params, headers, redirectTo))
})

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordForm)



// WEBPACK FOOTER //
// ./src/Pages/Auth/ResetPassword.js